import {
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import MDButton from "components/MDButton";
import React from "react";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";

export default function DeleteModal({ closeModal }) {
  const { modalData = {}, isLoading = false } = useSelector((state) => state.modal);
  const { deleteHandler, deleteId, deleteType = "" } = modalData;

  const handleDelete = async () => {
    if (typeof deleteHandler === "function") {
      await deleteHandler(deleteId, modalData);
    } else {
      closeModal();
    }
  };

  return (
    <>
      <DialogTitle
        id="draggable-dialog-title"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        Delete Confirmation
        <IconButton onClick={closeModal} edge="end" size="small">
          <CloseIcon fontSize="medium" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this {deleteType ? deleteType : "item"}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={closeModal} size="small" color="secondary">
          Cancel
        </MDButton>
        <MDButton
          onClick={handleDelete}
          size="small"
          color="error"
        >
          {isLoading ? <CircularProgress size={16} color="inherit" /> : "Delete"}
        </MDButton>
      </DialogActions>
    </>
  );
}
